// extracted by mini-css-extract-plugin
export default {"Price_slider_container":"PriceSlider_Price_slider_container__StUtO","Price_slider_subContainer":"PriceSlider_Price_slider_subContainer__Gop0o"};